import { Tile } from "@dash/tile";
import { useTheme } from "@emotion/react";
import React from "react";
import { Link } from "react-router-dom-v5-compat";

import { useClientManager } from "@megaron/react-clients";
import { Uuid } from "@megaron/uuid";

type Props = {
  crmCustomerUuid: Uuid | null;
};

export const SupportTicketActiveCartCard: React.FC<Props> = ({ crmCustomerUuid }) => {
  const theme = useTheme();
  const cartsQuery = useClientManager("fulfillment")
    .cartsQuery()
    .useQuery(
      {
        userId: crmCustomerUuid ?? undefined,
        isArchived: false,
        limit: 1,
        offset: 0,
      },
      { enabled: !!crmCustomerUuid },
    );

  const activeCart = cartsQuery.data?.items[0];

  if (!crmCustomerUuid || cartsQuery.isLoading || !activeCart) {
    return null;
  }

  return (
    <Link to={`/specjalista/carts/id/${activeCart.id}`} css={{ textDecoration: "none", color: "inherit" }}>
      <Tile
        css={{
          display: "flex",
          flexDirection: "column",
          gap: "0.25rem",
          borderColor: theme.colors.primary,
        }}
      >
        <span css={{ fontSize: "12px", color: theme.colors.secondaryText, fontWeight: 600 }}>
          Aktywny koszyk
        </span>
        <span css={{ fontSize: "14px", color: theme.colors.primary, fontWeight: 700 }}>{activeCart.id}</span>
      </Tile>
    </Link>
  );
};
